export const BlackMain = "#202024";
export const BlackSecondary = "#121214";
export const BlueMain = "#1ca1d2";
export const PrimaryColorHover = "#187ea4";
export const GreyLight = "#737380";
export const RedMain = "#d34242";
export const GreenMain = "#0cd362";
export const IconColor = "#a8a8b3";
